import React, { useEffect } from 'react';
import cn from 'classnames';

import Text from './Text';

import * as styles from './EventBanner.module.css';

const EventBanner = ({ data = {}, isOpen, setShow }) => {
  const initialShow = data.show;

  const onClose = e => {
    if (e) e.stopPropagation();
    setShow(false);
  };

  useEffect(() => {
    setShow(initialShow);
  }, [initialShow, setShow]);

  if (!data) return null;
  return (
    <div
      aria-hidden={!isOpen || null}
      className={cn(styles.root, { [styles.isOpen]: isOpen })}
      style={{ backgroundColor: data.colorBackground }}
      /* We want the tab index here to focus trap inside the list on open */
      /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
      tabIndex="0"
      onClick={() => window.open(data.url, '_blank')}
    >
      <style>
        {`
            .${styles.root} {
                --color-background: ${data.colorBackground};
                --color-label: ${data.colorLabel};
                --color-text: ${data.colorText};
            }
        `}
      </style>
      <button
        className={cn(styles.close)}
        aria-label="Close"
        onClick={onClose}
        tabIndex="0"
      >
        <span aria-hidden>&times;</span>
      </button>
      <div className={styles.left}>
        <Text className={cn(styles.label)} text={data.label} />
        <Text className={cn(styles.title)} text={data.title} />
        <Text className={cn(styles.subtitle)} text={data.subtitle} />
      </div>

      <div className={styles.right}>
        <Text className={cn(styles.date)} text={data.date} />
        <Text className={cn(styles.location)} text={data.location} />
        <Text className={cn(styles.cta)} text={data.cta} />
      </div>
    </div>
  );
};

export default EventBanner;
